import { useCallback, useReducer } from 'react'
import { saveAs } from 'file-saver'
import { decorateFetch } from '../api'
import cookies from 'js-cookie'

const fetch = decorateFetch(
  window.fetch,
  cookies,
  window.location,
  window.localStorage
)

// Example: attachment;filename=Atestation_flowMap_Dec1819.pdf
const parseContentDisposition = (str) => {
  str = str.slice('attachment;filename='.length)
  return str.slice(0, str.length)
}

interface DownloadFileState {
  readonly isIdle: boolean
  readonly isSuccess: boolean
  readonly isError: boolean
  readonly isFetching: boolean
  readonly error: Error | undefined
}

type DownloadFileAction =
  | {
      readonly type: 'SET_FETCHING'
    }
  | { readonly type: 'SET_SUCCESS' }
  | { readonly type: 'SET_ERROR'; readonly payload: Error }

const reducer = (state: DownloadFileState, action: DownloadFileAction) => {
  switch (action.type) {
    case 'SET_FETCHING':
      return {
        isFetching: true,
        isIdle: false,
        isSuccess: false,
        isError: false,
        error: undefined
      }
    case 'SET_SUCCESS':
      return { ...state, isFetching: false, isIdle: true, isSuccess: true }
    case 'SET_ERROR':
      return {
        ...state,
        isFetching: false,
        isIdle: true,
        isError: true,
        error: action.payload
      }
  }
}

export function useDownloadFile() {
  const [state, dispatch] = useReducer(reducer, {
    isFetching: false,
    isIdle: true,
    isSuccess: false,
    isError: false,
    error: undefined
  })
  const downloadFile = useCallback(async (url: string, fetchOptions) => {
    dispatch({ type: 'SET_FETCHING' })
    try {
      const path = url.startsWith('/') ? url : `/${url}`
      const response = await fetch(`/Contrast/api/ng${path}`, fetchOptions)
      const blob = await response.blob()
      let filename = 'untitled'
      const contentDisposition = response.headers.get('content-disposition')
      if (contentDisposition) {
        filename = parseContentDisposition(contentDisposition)
      }
      saveAs(blob, filename)
      dispatch({ type: 'SET_SUCCESS' })
    } catch (e) {
      dispatch({ type: 'SET_ERROR', payload: e })
      console.error(e)
    }
  }, [])

  return {
    ...state,
    downloadFile
  }
}
